import { render, staticRenderFns } from "./ecg-icon.vue?vue&type=template&id=0f159680"
import script from "./ecg-icon.vue?vue&type=script&lang=ts"
export * from "./ecg-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports